import React from 'react';
import { Button } from 'react-bootstrap';

const CTASection = ({state, onLogin}) => {
  return (
    <section className="my-5 cta-section text-center">
      <h2>Хочете записати дитину до дитячого садочку?</h2>
      <p>Натисніть на кнопку, авторизуйтесь та заповніть заявку</p>
      {state === "authsuccess" ? <Button variant="primary" href="profile" >Подати заявку</Button> : <Button variant="primary" onClick={onLogin} >Подати заявку</Button>  }
    </section>
  );
};

export default CTASection;